import { render, staticRenderFns } from "./fileConfirm.vue?vue&type=template&id=28d11d99&scoped=true&"
import script from "./fileConfirm.vue?vue&type=script&lang=js&"
export * from "./fileConfirm.vue?vue&type=script&lang=js&"
import style0 from "./fileConfirm.vue?vue&type=style&index=0&id=28d11d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d11d99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d11d99')) {
      api.createRecord('28d11d99', component.options)
    } else {
      api.reload('28d11d99', component.options)
    }
    module.hot.accept("./fileConfirm.vue?vue&type=template&id=28d11d99&scoped=true&", function () {
      api.rerender('28d11d99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/fileConfirm.vue"
export default component.exports